export const appInstallations = ($http: HttpApi) => ({
  list: () => $http.$get('/builder/app_installations'),
});
